<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import {listClubCompetitionOrder, listClubSignOrder} from "@/api/club/club.js";
import YTActivitySignOrderState from "@/components/YTActivitySignOrderState/index.vue";
import {activitySignOrderStateEnum} from "@/enum/activitySignOrderStateEnum.js"

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

// 报名状态枚举
const signStateEnum = activitySignOrderStateEnum

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  orderTime: [],
  orderState: null,
  startDate: null,
  endDate: null,
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    // 处理订单时间、驿站id
    formData.startDate = formData.orderTime[0] ? moment(formData.orderTime[0]).format("YYYY-MM-DD") : null;
    formData.endDate = formData.orderTime[1] ? moment(formData.orderTime[1]).format("YYYY-MM-DD") : null;
    // 搜索实物商品
    const res = await listClubCompetitionOrder(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.orderTime = []
  formData.orderState = null
  formData.startDate = null
  formData.endDate = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '报名编号', key: 'orderNo', nowrap: true },
  { title: '会员手机', key: 'phone', nowrap: true },
  { title: '报名状态', key: 'orderState', nowrap: true },
  { title: '创建时间', key: 'orderTime', nowrap: true },
  { title: '操作', key: 'controls', width: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 获取详情信息
const getDetail = (info) => {
  router.push({path: "/editClubCompetitionSign", query: {orderNo: info.orderNo}})
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="max-width: 400px;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <el-form-item label="报名编号：" prop="keyword">
        <el-input v-model="formData.keyword" placeholder="请输入报名编号"></el-input>
      </el-form-item>
      <el-form-item label="报名时间：" prop="orderTime">
        <el-date-picker
            v-model="formData.orderTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item label="报名状态：" prop="orderState">
        <el-select v-model="formData.orderState" placeholder="请选择报名状态" style="width: 240px">
          <el-option
              v-for="item in signStateEnum"
              :key="item.stateId"
              :label="item.stateName"
              :value="item.stateId"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'competitionOrder:view')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'competitionOrder:view')">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.orderState="{item}">
            <YTActivitySignOrderState class="mg_r_2" :state="item.orderState"></YTActivitySignOrderState>
          </template>

          <template v-slot:item.orderTime="{item}">
            {{item.orderTime ? moment(item.orderTime).format("YYYY-MM-DD") : '-'}}
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)" v-show="$handleHasBtnPermission('all', 'competitionOrder:view:info')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>